/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import moment from 'moment';
import {useRouter} from 'next/router';

import Link from '../../components/Link';
import {StoryBookIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';

const BlogPostCard = ({post, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const url = `/blog/${post.slug}?src=hub`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'blog', tag: tag.id, slug: post.slug});
    router.push(url);
  };

  const date = post.updated_at || post.published_at;

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer border border-gray-200 rounded-lg overflow-hidden transition hover:border-gray-300 hover:bg-gray-50"
    >
      <div className="flex h-32 justify-center items-center bg-gray-100">
        {post.feature_image
          ? <img src={post.feature_image} className="w-full h-full object-cover" loading="lazy" width="400" height="200" alt={post.title} />
          : <StoryBookIcon className="w-10 h-10 text-gray-400" />}
      </div>
      <div className="p-4">
        <Link href={url}>
          <h3 className="text-base font-semibold text-gray-900">{post.title}</h3>
        </Link>
        <span className="mt-0.5 block text-sm text-gray-500">
          {date && `Updated ${moment(date).fromNow()}`}
          {post.reading_time && ` · ${post.reading_time} min read`}
        </span>
      </div>
    </div>
  );
};

export default BlogPostCard;
